import ApiService from '@/common/api.service'

const state = {
  commercialClient: null,
  loadingCommercialClient: false,
};

const getters = {
  commercialClient(state) {
    return state.commercialClient;
  },
  loadingCommercialClient(state) {
    return state.loadingCommercialClient;
  },
}

const actions = {
  getCommercialClient(context, body) {
    context.commit('setLoadingCommercialClient', true);
    return new Promise((resolve, reject) => {
      ApiService.get('/commercial_client/customer', body)
        .then(response => {
          context.commit(
            'setCommercialClient',
            response.data.commercial_customer
          );
          context.commit('setLoadingCommercialClient', false);
          resolve(response.data.commercial_customer);
        })
        .catch(({ response }) => {
          context.commit('setLoadingCommercialClient', false);
          reject(response);
        });
    });
  }
}

const mutations = {
  setCommercialClient(state, location) {
    state.commercialClient = location;
  },
  setLoadingCommercialClient(state, status) {
    state.loadingCommercialClient = status;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
}